import script from "./slide3.vue?vue&type=script&lang=tsx"
export * from "./slide3.vue?vue&type=script&lang=tsx"

import "./slide3.vue?vue&type=style&index=0&id=08e5a8fa&lang=less&scoped=true"

import exportComponent from "/mnt/data/tmp/bty-landing-page-2025_06_05T15_53_19/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e5a8fa"]])

export default __exports__